import { render } from "./ReservationComponent.vue?vue&type=template&id=8b885a36"
import script from "./ReservationComponent.vue?vue&type=script&lang=js"
export * from "./ReservationComponent.vue?vue&type=script&lang=js"

import "./ReservationComponent.vue?vue&type=style&index=0&id=8b885a36&lang=css"

import exportComponent from "/home/ammar/Downloads/inso_app/isoassurance/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__